// codegen:start {preset: barrel, include: './lib/*.{ts,tsx}', exclude: './lib/*.{test,spec}.{ts,tsx}'}
export * from './lib/scroll-restoration';
export * from './lib/scroll-to-top'; // codegen:end